import { useState, useEffect } from "react";
import HeroPost from "./hero-post";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function HeroSlider({ posts }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    appendDots: dots => (
      <div style={{ position: 'absolute', bottom: '20px', width: '100%' }}>
        <ul style={{ margin: '0px' }}> {dots} </ul>
      </div>
    ),
  };

  return (
    <div className="hero-slider relative">
      <Slider {...settings}>
        {posts.map((post) => (
          <div key={post.id}>
            <HeroPost 
              title={post.title}
              coverImage={post.feature_image}
              date={post.published_at}
              updatedAt={post.updated_at}
              author={post.primary_author}
              slug={post.slug}
              excerpt={post.excerpt}
              averageRating={post.averageRating || 0}
              tags={post.tags}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
